export const MOBILE_MAX_WIDTH = '1023px';
export const GOOGLE_ANALYTICS_INTERACTION_HIT_FALSE = 'False';
